
import NativeClient from "@/client/native-client";
import { BannerData } from "@/types/home";
import { defineComponent, SetupContext, PropType, ref, onMounted, nextTick, ComponentPublicInstance } from "vue";
import BannerItem from "./BannerItem.vue";
/** スクロールイベントのIF */
interface HTMLElementEvent<T extends HTMLElement> extends Event {
  target: T;
}

export default defineComponent({
  name: "BannerList",
  components: { BannerItem },
  props: {
    /**
     * 画像を表示するデータ配列
     */
    list: {
      type: Array as PropType<BannerData[]>,
      default: () => []
    },
    position: {
      type: Number,
      default: 0,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const startX = ref(0);
    const moveX = ref(0);
    const onClick = (id: number) => {
      context.emit("on-click", id);
    };

    const getBannerList = () => {
      const bannerList = Array<BannerData>();
      bannerList.length = 0;
      for (let i = 0; i < props.list.length; i++) {
        bannerList.push(props.list[i]);
      }
      return bannerList;
    };
    const scroll = ref<ComponentPublicInstance<HTMLInputElement>>();

    const setScrollTo = (position: number) => {
      scroll.value?.scrollTo({top: 0, left: (scroll.value?.scrollWidth / props.list.length) * position});
    };

    const bannerScroll = () => {
      NativeClient.sendDebugLog("BannerList bannerScroll props.position=" + props.position);
      setScrollTo(props.position);
    };

    onMounted(async () => {
      await nextTick(() => {
        setScrollTo(props.position);
      });
    });

    const touchStart = (e: TouchEvent) => {
      startX.value = e.touches[0].pageX;
      // NativeClient.sendDebugLog("BannerList touchStart startX=" + startX.value );
    };
    const touchMove = (e: TouchEvent) => {
      moveX.value = e.touches[0].pageX - startX.value;
      // NativeClient.sendDebugLog("BannerList touchMove moveX=" + moveX.value);
    };
    const touchEnd = (e: TouchEvent) => {
      // NativeClient.sendDebugLog("BannerList touchEnd moveX=" + moveX.value);
      if (moveX.value > 10) {
        context.emit("swipe-right");
      } else if (moveX.value < -10) {
        context.emit("swipe-left");
      }
      moveX.value = 0;
      startX.value = 0;
    };

    return {
      onClick,
      getBannerList,
      scroll,
      setScrollTo,
      bannerScroll,
      touchStart,
      touchMove,
      touchEnd
    };
  }
});
